import { render, staticRenderFns } from "./SystemAdmin.vue?vue&type=template&id=8c5e4b46&"
import script from "./SystemAdmin.vue?vue&type=script&lang=js&"
export * from "./SystemAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports